(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filter-bar"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilterBar extends HTMLElement {
    connectedCallback() {
      this.bar = this;
      this.drawer = this.querySelector('[data-cfb-drawer]');

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cfb-open]') && this.drawer) {
          this.drawer.showModal();
          return;
        }
        if (event.target.closest('[data-cfb-close]') && this.drawer) {
          this.drawer.close();
          return;
        }
        if (event.target === this.drawer) {
          this.drawer.close();
          return;
        }
        const unitSwitch = event.target.closest('[data-unit-switch]');
        if (unitSwitch && this.bar) {
          this.setUnit(this.bar.getAttribute('data-size-unit') === 'eu' ? 'us' : 'eu');
        }
      });

      /* A size button can stand for several filter values (Euro 40 covers US 9
         and 9.5), but a <label> only toggles its first input — mirror the rest
         so the whole Euro size applies or clears together. */
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (!input.matches || !input.matches('.cfb-size .cfb-input')) return;
        const button = input.closest('.cfb-size');
        if (!button) return;
        button.querySelectorAll('.cfb-input').forEach((box) => {
          box.checked = input.checked;
        });
      });

      const sortSelect = this.querySelector('[data-cfb-sort-select]');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          sortSelect.closest('form').submit();
        });
      }
    }

    /* Single place that owns the unit state. The [data-size-unit] attribute on
       the host drives which of the eu/us label spans is shown. */
    setUnit(unit) {
      if (!this.bar) return;
      this.bar.setAttribute('data-size-unit', unit);

      this.querySelectorAll('[data-unit-switch]').forEach((s) => {
        s.setAttribute('aria-checked', unit === 'eu' ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('collection-filter-bar')) {
    customElements.define('collection-filter-bar', CollectionFilterBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
